module.exports = __webpack_public_path__ + "static/media/NewsLetterBg.86e2c6b4.png";